import type { RoutePermission, UserNavigationState } from '$lib/app/guards';
import { UserNavigationStates } from '$lib/app/guards/navigation-state';

export const ROUTE_CONFIG: Record<string, RoutePermission> = {
	'/': {
		path: '/',
		public: true
	},
	'/signin': {
		path: '/signin',
		public: true,
		redirectIfAuth: '/admin'
	},
	'/privacy': {
		path: '/privacy',
		public: true
	},
	'/terms': {
		path: '/terms',
		public: true
	},
	'/[tag]': {
		path: '/[tag]',
		public: true
	},
	'/admin': {
		path: '/admin',
		requireAuth: true,
		requireNotBanned: true,
		requireActiveStreamer: false,
		allowedStates: [
			UserNavigationStates.INACTIVE_USER,
			UserNavigationStates.ACTIVE_USER,
			UserNavigationStates.SUPERUSER
		],
		redirectIfIncomplete: '/onboard'
	},
	'/admin/[tag]': {
		path: '/admin/[tag]',
		requireAuth: true,
		requireNotBanned: true,
		requireStreamAccess: true,
		allowedStates: [
			UserNavigationStates.INACTIVE_USER,
			UserNavigationStates.ACTIVE_USER,
			UserNavigationStates.SUPERUSER
		]
	},
	'/admin/streams': {
		path: '/admin/streams',
		requireAuth: true,
		requireNotBanned: true,
		requireSuperuser: true,
		allowedStates: [UserNavigationStates.SUPERUSER]
	},
	'/admin/speakers': {
		path: '/admin/speakers',
		requireAuth: true,
		requireNotBanned: true,
		requireSuperuser: true,
		allowedStates: [UserNavigationStates.SUPERUSER]
	},
	'/admin/blacklist-hits': {
		path: '/admin/blacklist-hits',
		requireAuth: true,
		requireNotBanned: true,
		requireSuperuser: true,
		allowedStates: [UserNavigationStates.SUPERUSER]
	},
	'/admin/stats': {
		path: '/admin/stats',
		requireAuth: true,
		requireNotBanned: true,
		requireSuperuser: true,
		allowedStates: [UserNavigationStates.SUPERUSER]
	},
	'/admin/stats/[stream_tag]': {
		path: '/admin/stats/[stream_tag]',
		requireAuth: true,
		requireNotBanned: true,
		requireSuperuser: true,
		allowedStates: [UserNavigationStates.SUPERUSER]
	},
	'/onboard': {
		path: '/onboard',
		requireAuth: true,
		requireNotBanned: true,
		allowedStates: [
			UserNavigationStates.NEW_USER,
			UserNavigationStates.PENDING_APPROVAL,
			UserNavigationStates.REJECTED
		],
		redirectIfComplete: '/admin'
	},
	'/account': {
		path: '/account',
		requireAuth: true,
		requireNotBanned: true
	}
};

export function getRouteConfig(path: string): RoutePermission | undefined {
	return ROUTE_CONFIG[path];
}

export function isPublicRoute(path: string): boolean {
	const config = ROUTE_CONFIG[path];
	return config?.public ?? false;
}

export function getRedirectForState(state: UserNavigationState): string {
	switch (state) {
		case UserNavigationStates.UNAUTHENTICATED:
			return '/signin';
		case UserNavigationStates.BANNED:
			return '/';
		case UserNavigationStates.NEW_USER:
		case UserNavigationStates.PENDING_APPROVAL:
		case UserNavigationStates.REJECTED:
			return '/onboard';
		case UserNavigationStates.INACTIVE_USER:
		case UserNavigationStates.ACTIVE_USER:
		case UserNavigationStates.SUPERUSER:
			return '/admin';
		case UserNavigationStates.VIEWER:
			return '/';
		default:
			return '/';
	}
}
